module.exports = __webpack_public_path__ + "static/media/Scheduled-Group-Departures.a86f2117.jpg";